import React, { FC } from 'react';
import { Box } from '@ch/common/components/box';
import { Text } from '@ch/common/components/text';
import TextProps from '@ch/common/components/text/types';
import { Question } from '@ch/common/types/data';
import { useData } from '../use-data';
import { useQuizDescription } from './hooks/use-quiz-description';

const titleProps: TextProps = {
  $size: 'sm',
  $color: 'grayDarker',
  $m: [0, 0, 5],
};

const valueProps: TextProps = {
  $size: 'sm',
  $color: 'black',
  $m: [0, 0, 10],
};

const QuizFieldDescription: FC<Question> = props => {
  const {
    data: {
      keywords: { description, studyName },
    },
  } = useData();
  const { item } = useQuizDescription(props);

  if (!item) {
    return null;
  }
  const { name, information: info } = item;

  return (
    <Box $bgColor="grayLighter" $m={[10, 0, 0]} $radius={4} $p={[15, 15, 5]}>
      {studyName && <Text {...titleProps}>{studyName}</Text>}
      {name && <Text {...valueProps}>{name}</Text>}
      {description && <Text {...titleProps}>{description}</Text>}
      {info && <Text {...valueProps}>{info}</Text>}
    </Box>
  );
};

export default QuizFieldDescription;
